<template>
  <div class="hello">
    <p class="tip">选科依据：教育部印发《普通高校本科招生专业选考科目要求指引（通用版）》</p>
    <div class="filter">
      <div class="type">
        <span :class="current==1?'active':''" @click="tab_change(1)">选科匹配专业</span><span :class="current==2?'active':''"
          @click="tab_change(2)">按专业选科</span><span :class="current==4?'active':''" @click="tab_change(4)">按成绩选科</span>
        <span class="xgk" @click="goDetail('second')">新高考目标订制</span>

      </div>
      <div class="one flex" v-show="current==1">
        <div class='progress'>
          <el-progress type="circle" :show-text="false" :percentage="percentage" :format="format" color="#C10B17">
          </el-progress>
          <span>{{total}}个专业</span>
        </div>

        <div>
          <div class="one1 flex">
            <span>首选科目:</span>
            <div> <template>
                <el-radio-group @change="kemu_change" v-model="radio" fill="#C10B17" text-color='#C10B17' size="medium">
                  <el-radio :label="1" fill="#C10B17" text-color='#C10B17'>物理</el-radio>
                  <el-radio :label="4" fill="#C10B17" text-color='#C10B17'>历史</el-radio>
                </el-radio-group>
              </template>
            </div>
          </div>
          <div class="one1 flex">
            <span>再选科目:</span>
            <el-checkbox-group v-model="checkedCities" text-color='#C10B17' fill='#C10B17' style="text-align: left;"
              :max="2" @change="kemu_change">
              <el-checkbox v-for="item in options" :label="item.value" :key="item.value" text-color='#C10B17'
                fill='#C10B17'>{{item.label}}</el-checkbox>
            </el-checkbox-group>

          </div>
        </div>
      </div>
      <div v-if="current==2" class="one flex">
        <div class="major">
          <span style="color: gray;font-weight: bold;">专业选择</span>
          <div>
            <span v-for="(item,index) in majorList" :class="index==checkedNo?'tab_active':'major_one'"
              @click="major_change(item,index)">
              {{item.name}}
            </span>
          </div>
          <div class="more_major">
            <!--   <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox> -->
            <div style="margin: 15px"></div>
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="(item1,index) in majorList[checkedNo].children" :label="item1" :key="index"
                style="width: 150px;font-size: 16px;margin-bottom: 15px;">
                {{item1.name}}
              </el-checkbox>
            </el-checkbox-group>
            <!--  <div>
              <span>
                已选
              </span> <span v-for="(item,index) in checkedCities">{{item.name}}</span>
            </div> -->
            <el-button type="danger" @click="change(1)">确定</el-button>
          </div>
        </div>
        <div>
          <div class='progress'>
            <el-progress type="circle" :show-text="false" :percentage="percentage" :format="format" color="#C10B17">
            </el-progress>
            <span class="span1">{{total}}个专业</span>
          </div>
        </div>
      </div>

      <div class="one" v-if="current==3">
        <div class="flex major">
          <span style="color: gray;font-weight: bold;">职业选择</span>
          <div>
            <span class="career_name" v-for="(item,index1) in careerList" :key="index1"
              :class="index1==checkedNo?'tab_active':''" @click="career_change(item,index1)">
              {{item.name}}
            </span>
          </div>
          <div class="more_major">
            <!--  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
            </el-checkbox> -->
            <div style="margin: 15px"></div>
            <el-checkbox-group v-model="checkedCities1" @change="handleCheckedCitiesChange1">
              <el-checkbox v-for="(item2,index) in careerList[checkedNo].children" :label="item2" :key="index"
                style="width: 200px;font-size: 16px;margin-bottom: 15px;">
                {{item2.name}}
              </el-checkbox>
            </el-checkbox-group>
            <!--  <div>
              <span>
                已选
              </span> <span v-for="(item,index) in checkedCities">{{item.name}}</span>
            </div> -->
            <el-button type="danger" @click="change(2)">确定</el-button>
          </div>
        </div>
      </div>

      <div class="one flex" v-show="current==4">
        <div class='progress'>
          <el-progress type="circle" :show-text="false" :percentage="percentage" :format="format" color="#C10B17">
          </el-progress>
          <span>{{total}}个专业</span>
        </div>
        <div>
          <div style="color: #C20C18;text-align: left;" v-show="data.length!=0">根据您的成长记录，按照最优成绩推荐选课方式如下</div>
          <div style="color: #C20C18;text-align: left;" v-show="data.length==0">没有符合成绩的选科，请前往成长记录添加</div>
          <div>
            <div class="one1 flex">
              <span>首选科目:</span>
              <div> <template>
                  <el-radio-group @change="kemu_change1" v-model="radio2" fill="#C10B17" text-color='#C10B17'
                    size="medium">
                    <el-radio :label="1" fill="#C10B17" text-color='#C10B17'>物理</el-radio>
                    <el-radio :label="4" fill="#C10B17" text-color='#C10B17'>历史</el-radio>
                  </el-radio-group>
                </template>
              </div>
            </div>
            <div class="one1 flex">
              <span>再选科目:</span>
              <el-checkbox-group v-model="checkedCities2" text-color='#C10B17' fill='#C10B17' style="text-align: left;"
                :max="2" @change="kemu_change1">
                <el-checkbox v-for="item in options" :label="item.value" :key="item.value" text-color='#C10B17'
                  fill='#C10B17'>{{item.label}}</el-checkbox>
              </el-checkbox-group>

            </div>
          </div>


        </div>
      </div>
      <!-- <div class="two flex">
        <img src="../../assets/app.png" alt="">
        <div>
          <p>学科关联性</p>
          <p>强</p>
        </div>
      </div> -->
      <!-- <div class="one flex">
        <span>选择专业</span>
        <span>
          <el-select v-model="level1_value" placeholder="请选择一级专业" @change="change_level1" style="margin-right: 30px;">
            <el-option v-for="item in level1" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </span>
        <span>
          <el-select v-model="level2_value" placeholder="请选择二级专业" @change="change_level2">
            <el-option v-for="item in level2" :key="item.value" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </span>
      </div> -->
    </div>
    <el-empty v-show="data.length==0" description="您还没有选择科目"></el-empty>
    <div v-show="data.length!=0 &&current!=1">
      <div class="tablehead flex">
        <span style="width:370px;">专业名称</span>
        <span style="width:370px;">选考建议</span>
        <span style="width: 100px;">专业代码</span>
        <span style="width:100px;">修业年限</span>
        <span style="width: 170px;">学位门类</span>
      </div>
      <div class="tablemain flex">
        <div v-for="(item,index) in data" class="flex">
          <span style="width:370px;font-weight: bold;color: #C20C18;">{{item.major_name}}</span>
          <span style="width:370px;" v-if="item.limit">
            <span style="margin-right: 10px;">首选:{{item.limit.limit1_zn}}</span>
            <span style="margin-right: 10px;">次选:{{item.limit.limit2_zn}}</span>
            <span style="margin-right: 10px;">再选:{{item.limit.limit3_zn}}</span>
          </span>
          <span style="width:370px;" v-if="item.limit2">
            <span style="margin-right: 10px;">首选:{{item.limit2.limit1_zn}}</span>
            <span style="margin-right: 10px;">次选:{{item.limit2.limit2_zn}}</span>
            <span style="margin-right: 10px;">再选:{{item.limit2.limit3_zn}}</span>
          </span>
          <span style="width:100px;">{{item.major_code}}</span>
          <span style="width:100px;">{{item.year}}</span>
          <span style="width:170px;">{{item.major_type}}</span>
          <span style="width:170px;">
            <button type="button" @click="goDetail(item)">查看详情</button>

          </span>
        </div>
      </div>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
        style="margin: 60px auto;" @current-change="current_change" v-if="pageshow">
      </el-pagination>
    </div>
    <div v-show="data.length!=0 &&current==1">
      <div class="tablehead flex">
        <span style="width:370px;">专业名称</span>
        <span style="width:370px;">选考建议</span>
        <span style="width: 100px;">专业代码</span>
        <span style="width:100px;">修业年限</span>
        <span style="width: 170px;">学位门类</span>
      </div>
      <div class="tablemain flex">
        <el-collapse accordion class="collapse2" v-model='activeCol' v-show="activeName!='first'">
          <el-collapse-item v-for="(item,index) in data" :key="index" :name=index>
            <template slot="title">
              <div class="flex">
                <span style="width:370px;font-weight: bold;color: #C20C18;"
                  @click.stop="stopclick">{{item.major_name}}</span>
                <span style="width:370px;" v-if="item.limit" @click.stop="stopclick">
                  <span style="margin-right: 10px;">首选:{{item.limit.limit1_zn}}</span>
                  <span style="margin-right: 10px;">次选:{{item.limit.limit2_zn}}</span>
                  <span style="margin-right: 10px;">再选:{{item.limit.limit3_zn}}</span>
                </span>
                <span style="width:370px;" v-if="item.limit2" @click.stop="stopclick">
                  <span style="margin-right: 10px;">首选:{{item.limit2.limit1_zn}}</span>
                  <span style="margin-right: 10px;">次选:{{item.limit2.limit2_zn}}</span>
                  <span style="margin-right: 10px;">再选:{{item.limit2.limit3_zn}}</span>
                </span>
                <span style="width:100px;" @click.stop="stopclick">{{item.major_code}}</span>
                <span style="width:100px;" @click.stop="stopclick">{{item.year}}</span>
                <span style="width:170px;" @click.stop="stopclick">{{item.major_type}}</span>
                <span style="width:170px;">
                  <button type="button" @click="goDetail(item)">查看详情</button>
                  <button type="button" @click="showSchool(item)">开设院校</button>
                </span>
              </div>
            </template>
            <div v-if="schoolList.length==0" style="text-align: center;font-weight: bold;">您的分数在此专业暂无匹配院校</div>
            <div class="schoolList">
              <div class="flex schoolOne" v-for="(item,index) in schoolList" :key="index">
                <img :src="$imgUrl+item.school.badge_img" alt="">
                <div class="schoolDetail">
                  <div style="font-weight: bold;font-size: 20px;"> {{item.school_name}}</div>
                  <div>{{item.batch_name}}</div>
                  <div>院校代码：{{item.school_code}}</div>
                </div>
                <div class="majorDetail">
                  <div style="text-align: left;font-weight: bold;">{{item.major_name}}(专业代码:{{item.major_code}})</div>
                  <div style="text-align: left;">{{item.major_detail}}</div>
                  <div class="flex" style="justify-content: space-between;width: 100%;">
                    <span style="color: #C20C18;margin-right: 10px;">{{item.year}}年</span>
                    <span style="margin-right: 10px;">录取分：{{item.score_actual==0?'暂无':item.score_actual}}</span>
                    <span style="margin-right: 10px;">预测冲：{{item.score_danger}}</span>
                    <span style="margin-right: 10px;">预测稳：{{item.score_safe}}</span>
                    <span>预测保：{{item.score_guarantee}}</span>
                  </div>
                </div>
                <button type="button" @click="goDetail1(item)">院校详情</button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

      </div>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
        style="margin: 60px auto;" @current-change="current_change" v-if="pageshow">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        data: [],
        radio2: 1,
        checkedCities2: [],
        checkedNo: 0,
        current: 1,
        percentage: 0,
        pageshow: true,
        radio: 1,
        checkedCities: [2, 3],
        checkedCities1: [],
        options: [{
          label: '化学',
          value: 2
        }, {
          label: '生物',
          value: 3
        }, {
          label: '政治',
          value: 5
        }, {
          label: '地理',
          value: 6
        }],
        level1: [],
        level2: [],
        type_id: 34,
        level1_value: [],
        level2_value: [],
        page: 1,
        total: null,
        majorList: [{
          id: 34,
          name: "哲学类",
          pid: 3
        }],
        careerList: [{
          "id": 3,
          "code": "02030502",
          "level": 2,
          "name": "兽药技术人员"
        }],
        schoolList: [],
        activeCol: true
      }
    },
    created() {
      this.$http.majorTypeList().then(res => {
        this.level1 = res.data.list
      })
      let data = {
        first: this.radio,
        second: this.checkedCities[0],
        third: this.checkedCities[1],
        page: this.page
      }
      this.$http.majorSubjectSearch(data).then(res => {
        this.data = res.data.list
        this.total = res.data.total
        this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
      })
    },
    methods: {
      stopclick(event) {
        event.stopPropagation()
      },
      showSchool(item) {
        this.schoolList = []
        this.$http.majorSubjectSearchSchoolList({
          major_code: item.major_code
        }).then(res => {
          this.schoolList = res.data.list
        })
      },
      format(percentage) {
        percentage > 60 ? '优秀' : `${percentage}%`
      },
      handleCheckedCitiesChange(e) {
        console.log(e)
      },
      handleCheckedCitiesChange1(e) {

      },
      change(num) {
        if (num == 1) {
          let data = this.checkedCities.map(item => {
            return item.id
          })
          this.$http.subjectByMajor({
            type_id: data
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
            this.percentage = (res.data.count / res.data.all * 100).toFixed(2)
          })
        }
        if (num == 2) {
          let data1 = this.checkedCities1.map(item => {
            return item.id
          })
          this.$http.subjectByCareer({
            careers: data1
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count

          })
        }
        if (num == 3) {

        }
      },
      career_change(item, index) {
        this.checkedNo = index
        console.log(index)
        console.log(this.careerList[this.checkedNo])
      },
      major_change(item, index) {
        this.checkedNo = index
        console.log(index)
        console.log(this.majorList[this.checkedNo].children)

      },
      tab_change(index) {
        this.current = index
        this.checkedNo = 0
        this.count = 0
        this.percentage = 0
        this.page = 1
        if (index == 1) {
          let data = {
            first: this.radio,
            second: this.checkedCities[0],
            third: this.checkedCities[1],
            page: this.page
          }
          this.$http.majorSubjectSearch(data).then(res => {
            this.data = res.data.list
            this.total = res.data.total
            this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
          })
        }
        if (index == 2) {
          let data = {
            first: this.radio,
            second: this.checkedCities[0],
            third: this.checkedCities[1],
            page: this.page
          }
          this.$http.majorSubjectSearch(data).then(res => {
            this.data = res.data.list
            this.total = res.data.total
            this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
          })
          this.$http.getCustomSearch({
            batch_name: '本科一批',
            mode: 'major'
          }).then(res => {
            this.majorList = res.data.list
          })
        }
        if (index == 3) {
          let data = {
            first: this.radio,
            second: this.checkedCities[0],
            third: this.checkedCities[1],
            page: this.page
          }
          this.$http.majorSubjectSearch(data).then(res => {
            this.data = res.data.list
            this.total = res.data.total
            this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
          })
          this.$http.getCustomSearch({
            batch_name: '本科一批',
            mode: 'career'
          }).then(res => {
            this.careerList = res.data.list
            this.checkedNo = 0
          })
        }
        if (index == 4) {
          this.data = []
          this.$http.subjectSearchByScore().then(res => {
            if (res.data.check == false) {
              this.$message.error('没有符合成绩的选科')
              this.$confirm('没有符合成绩的选科,请先去成长记录添加成绩 是否前往?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.$router.push('/growthRecord')
              }).catch(() => {

              });
              return
            } else {
              this.radio2 = res.data.scores[0].type
              this.checkedCities2 = [res.data.scores[1].type, res.data.scores[2].type]
              let data = {
                first: this.radio2,
                second: this.checkedCities2[0],
                third: this.checkedCities2[1],
                page: this.page
              }
              this.$http.majorSubjectSearch(data).then(res => {
                this.data = res.data.list
                this.total = res.data.total
                this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
              })

            }
          })
        }
      },
      current_change(e) {
        this.activeCol = false
        let current = this.current
        if (current == 1) {
          this.page = e
          let data = {
            first: this.radio,
            second: this.checkedCities[0],
            third: this.checkedCities[1],
            cate_id: [],
            type_id: [],
            page: this.page
          }
          this.$http.majorSubjectSearch(data).then(res => {
            this.data = res.data.list
            this.total = res.data.total
            this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
          })
        }
        if (current == 2) {
          let data = this.checkedCities.map(item => {
            return item.id
          })
          this.$http.subjectByMajor({
            type_id: data,
            page: this.page
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
            console.log(this.data)
          })
        }
        if (current == 3) {
          let data1 = this.checkedCities1.map(item => {
            return item.id
          })
          this.$http.subjectByCareer({
            careers: data1,
            page: this.page
          }).then(res => {
            this.data = res.data.list
            this.total = res.data.count
          })
        }
        if (current == 4) {
          let data = {
            first: this.radio2,
            second: this.checkedCities2[0],
            third: this.checkedCities2[1],
            page: this.page
          }
          this.$http.majorSubjectSearch(data).then(res => {
            this.data = res.data.list
            this.total = res.data.total
            this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
          })
        }
      },
      change_level1(value) {
        console.log(value)
        for (let i = 0; i < this.level1.length; i++) {
          if (this.level1[i].id == value) {
            this.level2 = this.level1[i].childrenNode
          }
        }
        let data = {
          first: this.radio,
          second: this.checkedCities[0],
          third: this.checkedCities[1],
          cate_id: this.level1_value,
          type_id: this.level2_value,
          page: this.page
        }
        this.$http.majorSubjectSearch(data).then(res => {
          this.data = res.data.list
          this.total = res.data.total
          this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
        })
      },
      change_level2(value) {
        let data = {
          first: this.radio,
          second: this.checkedCities[0],
          third: this.checkedCities[1],
          cate_id: this.level1_value,
          type_id: this.level2_value,
          page: this.page
        }
        this.$http.majorSubjectSearch(data).then(res => {
          this.data = res.data.list
          this.total = res.data.total
          this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
        })
      },
      kemu_change() {
        if (this.checkedCities.length != 2) {
          return
        }
        let data = {
          first: this.radio,
          second: this.checkedCities[0],
          third: this.checkedCities[1],
          cate_id: this.level1_value,
          type_id: this.level2_value,
          page: this.page
        }
        this.$http.majorSubjectSearch(data).then(res => {
          this.data = res.data.list
          this.total = res.data.total
          this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
        })
      },
      kemu_change1() {
        if (this.checkedCities2.length != 2) {
          return
        }
        let data = {
          first: this.radio2,
          second: this.checkedCities2[0],
          third: this.checkedCities2[1],
          cate_id: this.level1_value,
          type_id: this.level2_value,
          page: this.page
        }
        this.$http.majorSubjectSearch(data).then(res => {
          this.data = res.data.list
          this.total = res.data.total
          this.percentage = (res.data.total / res.data.all * 100).toFixed(2)
        })
      },
      goDetail(item) {
        if (item == 'second') {
          this.$router.push('/futureEasy?activeName=' + item)
          return
        }
        this.$router.push('/specialtyDetail?id=' + item.major_code)
      },
      goDetail1(item) {
        this.$router.push('/schoolDetail?id=' + item.school.id)
      }
    }
  }
</script>

<style scoped lang="scss">
  .schoolList img {
    width: 70px;
    height: 70px;
    margin: 20px;
  }

  .schoolOne {
    border-bottom: 1px solid #e3e3e3;
    padding: 5px 0;
    justify-content: space-between;
  }

  .schoolDetail {
    font-size: 16px;
    width: 300px;
    text-align: left;
  }

  .majorDetail {
    font-size: 16px;

    width: 500px;
  }

  .schoolList .flex {
    width: 80%;
    margin: 0 auto;
  }

  .xgk {
    margin-left: -4px;
  }

  .progress {
    position: relative;

    .span1 {
      top: 60px;
    }

    span {
      position: absolute;
      top: 74px;
      left: 31px;
    }
  }

  .more_major {
    font-size: 16px;
    margin: 0 !important;
    text-align: left;
  }

  .career_name {
    width: 165px;
    margin-bottom: 10px;
    display: inline-block;
  }

  .tab_active {
    color: #C10B17;
    font-weight: bold;
  }

  .major {
    margin: 30px;
    text-align: left;

    button {
      margin-top: 20px;
    }

    span {
      margin-right: 30px;
    }
  }

  .major_one {
    position: relative;
    cursor: pointer;

  }

  .type {
    border-radius: 10px 10px 0px 0px;
    text-align: left;

    span {
      cursor: pointer;
      display: inline-block;
      width: 158px;
      height: 44px;
      line-height: 44px;
      background: #F2F2F2;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      text-align: center;
    }


    .active {
      background: #FFFFFF;
      border: 1px solid #EDEDED;

      color: #C10B17;
    }
  }

  .tip {
    color: #C10B17;
    text-align: left;
    margin-top: 20px;
  }

  .title {
    text-align: left;
    margin: 20px 0;
  }

  .one1 span {
    margin-right: 10px;
  }

  .tablemain {
    &>div {
      width: 100%;
    }

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;

    }

    span {

      line-height: 60px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }
  }



  .choose {
    margin-left: 50px;
  }

  .tablehead {
    text-align: left;
    position: sticky;
    top: 0;
    width: 100%;
    height: 51px;
    background: #FAFAFA;
    line-height: 51px;
    // margin-top: 20px;

    span {
      display: inline-block;
      // flex: 1;
      text-align: center;
      // margin-right: 20px;
    }
  }

  .two {
    img {
      width: 100px;
      height: 100px;
      margin-right: 30px;
    }
  }

  .filter {
    margin: 37px auto;

    width: 100%;

    select {
      margin-right: 10px;
    }

    .one {
      margin-right: 100px;
      padding: 10px 30px;
      border: 1px solid #E6E6E6;
      // padding: 30px;
      // height: 150px;

      span {
        margin-right: 20px;
      }

      &>div {
        margin-left: 30px;

        &>div {
          margin: 20px auto;
        }
      }
    }



    .el-dropdown-link {
      margin-bottom: 30px;
    }
  }
</style>
<style>
  .collapse2 .el-collapse-item__header {
    height: auto;
    line-height: auto;
    display: block;
  }

  .collapse2 .type {
    margin-top: 0px;
  }

  .el-collapse-item__arrow {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/view/new/chooseSubjects.vue